import React, { useState, useEffect, useCallback } from 'react';
import {
  Space, Grid, Avatar, message, Popconfirm, Dropdown, Menu, Input, Card, Row, Col, Spin
} from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NewRecipePopover from '../components/recipe/NewRecipeButton';
import { MoreOutlined } from '@ant-design/icons';
import RecipeCard from '../components/RecipeCard';


const { useBreakpoint } = Grid;
const { Search } = Input;

function getDomain(url) {
  if (!url) return null;
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return null;
  }
}

// assume backend returns: Array<{ category: string; recipes: RecipeRecord[] }>
const RecipeListPage = () => {
  const [data, setData] = useState([]); //  CategoryRecipe[]
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [messageApi] = message.useMessage();


  const fetchRecipes = useCallback(async (q = '') => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/recipes${q ? `?q=${encodeURIComponent(q)}` : ''}`;
      const res = await axios.get(url, { withCredentials: true });
      setData(res.data); // [{ category, recipes: [...] }]
    } catch {
      messageApi.error('Failed to fetch recipes');
      setData([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchRecipes();
  }, [fetchRecipes]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchRecipes(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery, fetchRecipes]);

  const handleEdit = (recipe) => {
    navigate(`/ui/recipe/${recipe.id}`);
  };

  const handleDelete = async (recipe) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/recipes/${recipe.id}`, { withCredentials: true });
      messageApi.success('Recipe deleted');

      setData(prev => {
        const safePrev = Array.isArray(prev) ? prev : [];
        return safePrev
          .map(cat => ({
            ...cat,
            recipeLists: cat.recipeLists?.filter(list => list.recipe.id !== recipe.id) || []
          }))
          .filter(cat => cat.recipeLists?.length > 0);
      });
    } catch {
      messageApi.error('Failed to delete recipe');
    }
  };



  const menu = (record) => (
    <Menu>
      <Menu.Item key="edit" onClick={() => handleEdit(record.recipe)}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete">
        <Popconfirm
          title="Are you sure to delete this recipe?"
          onConfirm={() => handleDelete(record.recipe)}
          okText="Yes"
          cancelText="No"
        >
          Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  return (
    <Spin spinning={loading} tip="Loading recipes...">
      <div style={{ padding: screens.xs ? 12 : 24 }}>
        <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between', display: 'flex' }}>
          <Search
            placeholder="Search recipes"
            allowClear
            onChange={e => setSearchQuery(e.target.value)}
            style={{ maxWidth: 300 }}
            enterButton={false}
            value={searchQuery}
          />
          <NewRecipePopover />
        </Space>

        {data.map((group) => (
          <div key={group.recipeCategory} style={{ marginBottom: 32 }}>
            <h2 style={{ margin: '8px 0 16px' }}>{group.recipeCategory}</h2>

            <Row gutter={[16, 16]}>
              {group.recipeLists.map((record) => {
                const { recipe, keyPhoto, ingredients, caloriesPerPortion } = record;
                const domain = getDomain(recipe.sourceURL);

                return (
                  <Col xs={24} sm={12} md={8} lg={6} key={recipe.id}>
                    <RecipeCard
                      recipe={recipe}
                      record={record}
                      keyPhoto={keyPhoto}
                      ingredients={ingredients}
                      caloriesPerPortion={caloriesPerPortion}
                      domain={domain}
                      menu={menu}
                      navigate={navigate}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        ))}
      </div>
    </Spin>
  );
};

export default RecipeListPage;



